const roundElapsedMs = (startedAt, finishedAt) => {
  if (startedAt == null || finishedAt == null) {
    return null;
  }

  return Math.max(0, Math.round(finishedAt - startedAt));
};

export const createGraphPerfMetrics = (source = '-') => ({
  source,
  apiMs: null,
  renderMs: null,
  totalMs: null,
});

export const createErrorGraphPerfMetrics = () => createGraphPerfMetrics('error');

export const createApiGraphPerfMetrics = ({ source, requestStartedAt, responseArrivedAt }) => ({
  source: source || '-',
  apiMs: roundElapsedMs(requestStartedAt, responseArrivedAt),
  renderMs: null,
  totalMs: null,
});

export const createRenderGraphPerfMetrics = ({ requestStartedAt, renderStartedAt, renderFinishedAt }) => {
  if (renderStartedAt == null) {
    return null;
  }

  return {
    renderMs: roundElapsedMs(renderStartedAt, renderFinishedAt),
    totalMs: roundElapsedMs(requestStartedAt, renderFinishedAt),
  };
};
